import {RootState} from '../rootReducer';

export const guidingTourSelector = (state: RootState) => state.guidingTour;
